import { twMerge } from 'tailwind-merge';
import { BLOBS, classes } from './utils';

// Wrap in a `relative` parent and give content `relative z-10` so it paints above the blobs.
export default function BackgroundBlobs() {
  return (
    <div aria-hidden className={classes.background}>
      {BLOBS.map(([blobClass, blobStyle], i) => (
        <div
          key={i}
          style={blobStyle}
          className={twMerge(classes.blob, blobClass)}
        />
      ))}
    </div>
  );
}
